import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-526">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-527">
        <CTASection headline="Need High Availability for Your Systems?" body="Let's discuss how we can design infrastructure that keeps your business running around the clock." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-528" />
      </div>
    </section>;
}